import * as React from "react";
var Kicker = function (props) {
    var _a = React.useState(null), selection = _a[0], setSelection = _a[1];
    var handleChange = function (e) {
        setSelection(e.target.value === "" ? null : parseInt(e.target.value, 10));
    };
    return (React.createElement("label", { className: "kicker flex items-center gap-2 text-sm text-[var(--text-on-felt-soft)]" },
        React.createElement("span", null, "Kick player"),
        React.createElement("select", { className: "sj-input !min-h-[40px] !py-1", value: selection === null ? "" : selection, onChange: handleChange, "aria-label": "Kick player" },
            React.createElement("option", { value: "" }),
            props.players.map(function (player) { return (React.createElement("option", { value: player.id, key: player.id }, player.name)); })),
        React.createElement("button", { type: "button", className: "sj-btn !min-h-[40px] !px-3 !py-1 !text-sm", onClick: function () {
                if (selection) {
                    props.onKick(selection);
                }
            }, disabled: selection === null }, "Kick")));
};
export default Kicker;
